import Vue from 'vue'
import Filter from './Filter'
import ListItem from './ListItem'


if ( jQuery('#events-filter-wrapper').length > 0) {

    
    // Initialize main Vue app for the events filter/list
    let app = new Vue({
        components: {
            'events-filter': Filter,
            'events-list-item': ListItem,
        },
        el: '#events-filter-wrapper',
        data: {
        }
    });

    
}


